import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: {
    taxAlternatePayerName,
    taxAlternatePayerId
  },
} = checkout;

const validation2 = Yup.object().shape({
  [taxAlternatePayerId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxAlternatePayerId.invalidMsg)
  .required(taxAlternatePayerId.errorMsg),
  [taxAlternatePayerName.name]: Yup.string().required(taxAlternatePayerName.errorMsg),
});

export default validation2;
